module.exports = __webpack_public_path__ + "static/media/frlogo.7313e350.svg";